/* eslint-disable no-use-before-define */
export const userGql = `
  id
  avatar
  firstName
  lastName
  sellerLocation {
    name
    place_id
    latitude
    longitude
  }
  sellerRating
`

export const sellerGql = `
  id
  firstName
  lastName
`

export const payoutStatsGql = `
  id
  salesCount
  sales {
    total
    currencyCode
    completedAt
  }
  nextPayout
  revenue
  payouts {
    status
    type
    amount
    currencyCode
    gateway
    formattedGateway
  }
`

export const payoutsDetailsGql = `
  id
`

export const paymentMethodInfo = `
  id
  brand
  expMonth
  expYear
  last4
  gateway
  formattedGateway
  defaultMethod
`

export const shortViewerGql = `
  id
  email
  firstName
  lastName
  ordersCount
  phone
  avatar
`

export const fullViewerGql = `
  id
  email
  firstName
  lastName
  phone
  description
  avatar
  credits
  logins
  allergens
  diets
  emailVerified
  sellerLocation {
    name
    place_id
    latitude
    longitude
  }
  sellerSchedule {
    status
    mon
    tue
    wed
    thu
    fri
    sat
    sun
  }
  agreements {
    sellerTos
    clientTos
    privacyPolicy
    typhoidVaccine
    halal
  }
  roles {
    buyer
    seller
  }
`

export const lineItemGql = `
  id
  product {
    id
    name
    photo
    allergens
    diets
    price
    currencyCode
  }
  status
  quantity
`

export const orderGql = `
  id
  status
  lineItems {
    ${lineItemGql}
  }
  seller {
    ${sellerGql}
  }
  subTotal
  total
  taxesUSD
  currencyCode
  createdAt
  completedAt
  abandonedAt
  refundedAt
  reversedAt
  canceledAt
`

export const productInfo = `
  id
  name
  description
  photo
  price
  currencyCode
  allergens
  diets
`

export const schedule = `
  status
  mon
  tue
  wed
  thu
  fri
  sat
  sun
`

export const onboarding = `
  id
  firstName
  lastName
  email
  avatar
  description
  sellerLocation {
    name
    place_id
    latitude
    longitude
  }
  pickupInstructions
  sellerSchedule {
    ${schedule}
  }
  agreements {
    sellerTos
    typhoidVaccine
    halal
  }
  sellerProducts {
    id
  }
  uploads {
    national_ID
    typhoid_vaccine_card
  }
`
